import { Component, OnInit } from '@angular/core';
import {Filter} from '../../../../models/warranties/filter.model';
import {HttpService} from '../../../../services/http.service';
import {ActionPeriodList} from '../../../../models/action/action-period-list.model';

@Component({
  selector: 'app-action-period-list',
  templateUrl: './action-period-list.component.html',
  styleUrls: ['./action-period-list.component.scss']
})
export class ActionPeriodListComponent implements OnInit {

  actionPeriodList: ActionPeriodList;
  filter: Filter = new Filter();

  constructor(private http: HttpService) { }

  ngOnInit(): void {
    this.refreshList();
  }

  refreshList() {
    this.http.fetchAdminActionPeriods(this.filter).subscribe((res) => {
      this.actionPeriodList = Object.assign(new ActionPeriodList(), res);
    });
  }

  orderBy(field: string) {
    if (this.filter.orderBy == field) {
      if (this.filter.order == 'ASC')
        this.filter.order = 'DESC';
      else this.filter.order = 'ASC';
    }
    this.filter.orderBy = field;
    this.refreshList();
  }

  showDirectionImage() : string {
    if (this.filter.order == 'ASC') return 'assets/images/icon-sort-up.png';
    else return 'assets/images/icon-sort-down.png';
  }

  clearFilter() {
    this.filter = new Filter();
    this.refreshList();
  }

  changePage(count: number) {
    this.filter.page += count;
    this.refreshList();
  }
}
